import moment from "moment";
import {UPLOAD_TYPE_ALL} from "../../../consts/uploadtypes";

export const initialState = {
  filterConditions: {
    deviceId: "",
    appId: "",
    appVersion: "",
    diagnosisId: "",
    descriptionKeyword: "",
    uploadType: UPLOAD_TYPE_ALL,
    platform: 0,
    beginTime: moment().startOf("day").subtract(7, 'days'),
    endTime: moment().startOf("day")
  },
  tasks: [],
  // 当前列表实际使用的查询条件（点搜索时定格），翻页时沿用它，不受输入框里未搜索的改动影响
  query: null,
  // 当前列表对应的分页信息（服务端分页）
  pagination: {
    pageNum: 1,
    pageSize: 20,
    total: 0
  },
  loading: false
};
